// A page scroll lock shared by every overlay that covers the page (Dialog, Popover as a sheet).
// Counted, so stacked overlays release the page only when the last one goes.

import { useEffect } from 'react';

let locks = 0;
let saved = '';

export function useScrollLock(active: boolean): void {
  useEffect(() => {
    if (!active || typeof document === 'undefined') return undefined;
    if (locks === 0) {
      saved = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    }
    locks += 1;
    return () => {
      locks -= 1;
      if (locks === 0) document.body.style.overflow = saved;
    };
  }, [active]);
}
